import Chartist from 'ascom-chartist-logscale';

/**
 * Initializes Chartist library for drawing doughnut chart and returns options for it
 * @param chartData
 * @param isExpanded
 * @returns {{donut: boolean, donutWidth: number, showLabel: boolean, labelInterpolationFnc: function(*): string, height: string, plugins: *[]}}
 */
export function initDoughnutChart(chartData, isExpanded, isPrintver = false) {
    return {
        donut: true,
        height: isPrintver ? 300 : undefined,
        width: isPrintver ? 290 : undefined,
        donutWidth: isExpanded ? 100 : 65,
        showLabel: true,
        labelInterpolationFnc: value => (value > 0 ? value : ''),
        plugins: [
            Chartist.plugins.tooltip(),
            Chartist.plugins.legend({
                legendNames: chartData.map(series => series.meta),
                clickable: false,
                classNames: chartData.map(series => series.className),
            }),
        ],
    };
}

/**
 * Prepares data for and draws chart using "this.drawChart(ref, data)" call
 */
export function makeChart() {
    if (!this.content || this.needsAttention) {
        this.instanceChart = null;
        this.instanceDoughnutChart = null;
        return;
    }
    let data = this.chartData;

    let ref = this.$refs.widgetChartRef;
    // needs to check reference since it can be rendered in the next tick
    // because of component being nested to BaseWidget
    if (!ref) {
        this.$nextTick(() => this.drawChart(this.$refs.widgetChartRef, data));
    } else {
        this.drawChart(ref, data);
    }
}
